import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  CustomTabView,
  PageHeader,
  SelectEmpresas,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalOcorrencia from './ModalOcorrencia'
import useOcorrenciaEmpresa, { LOAD_MESSAGE } from './OcorrenciaEmpresaHook'
import { TabPanel } from 'primereact/tabview'

function OcorrenciaEmpresa({ dispatch, history }) {
  const { state, localDispatch } = useOcorrenciaEmpresa()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_REASONS_STANDARD:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMissingReasonStandard()
        break

      case LOAD_MESSAGE.GET_REASONS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMissingReasons(state.selectedEmpresaID)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>4.5 - Cadastro de Ocorrências de Produto</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-12 p-md-3">
              <SelectEmpresas
                companyId={state.selectedEmpresaID}
                onChange={value => localDispatch.onEmpresaChange(value)}
              />
            </div>
            <div className="p-col-12 p-md-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Btn onClick={() => localDispatch.onBtnNovo(state.selectedEmpresaID)}>Novo</Btn>
            </div>
          </div>
          <CustomTabView activeIndex={state.activeTab} onTabChange={localDispatch.onTabChange}>
            <TabPanel header={'Ocorrências Vinculadas'}>
              <DataTable
                selectionMode="single"
                onSelectionChange={e => localDispatch.onRowClicked(e.value)}
                value={state.ocorrencias}
                paginator={true}
                rows={10}
                emptyMessage={'Selecione a empresa desejada'}
                globalFilter={state.ocorrenciaFilter}
                header={<CustomDataTableHeader onChange={localDispatch.onChangeOcorrenciaFitler} />}
              >
                <Column field="sigla" header="Sigla" style={tableCellCentered()} />
                <Column field="company_code" header="Código Interno" style={tableCellCentered()} />
                <Column field="descricao" header="Descrição" />
                <Column field="type" header="Tipo" style={tableCellCentered()} />
                <Column
                  field="visible_picking"
                  header="Etapa Separação"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.visible_picking} />
                  )}
                />
                <Column
                  field="visible_delivery"
                  header="Etapa Entrega"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.visible_delivery} />
                  )}
                />
                <Column
                  field="devolucao_fisica"
                  header="Devolução Física"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.devolucao_fisica} />
                  )}
                />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered()}
                  body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.actived} />}
                />
              </DataTable>
            </TabPanel>
            <TabPanel header={'Ocorrências Padrões'} disabled={state.selectedEmpresaID === ''}>
              <DataTable
                value={state.ocorrenciasPadrao}
                paginator={true}
                rows={10}
                emptyMessage={'Nenhuma ocorrência padrão encontrada'}
                globalFilter={state.ocorrenciaPadraoFilter}
                header={
                  <CustomDataTableHeader onChange={localDispatch.onChangeOcorrenciaPadraoFitler} />
                }
              >
                <Column
                  header="#"
                  style={tableCellCentered(80)}
                  body={item => {
                    const checked = state.ocorrencias.some(
                      ocorrencia => ocorrencia.sigla === item.sigla,
                    )
                    return (
                      <CustomCheckbox
                        disabled={checked}
                        checked={checked}
                        onChange={() =>
                          localDispatch.onAddRemoveOcorrencia(
                            item,
                            state.selectedEmpresaID,
                            checked,
                          )
                        }
                      />
                    )
                  }}
                />
                <Column field="sigla" header="Sigla" style={tableCellCentered()} />
                <Column field="descricao" header="Descrição" />
                <Column field="type" header="Tipo" style={tableCellCentered()} />
                <Column
                  field="visible_picking"
                  header="Etapa Separação"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.visible_picking} />
                  )}
                />
                <Column
                  field="visible_delivery"
                  header="Etapa Entrega"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.visible_delivery} />
                  )}
                />
                <Column
                  field="devolucao_fisica"
                  header="Devolução Física"
                  style={tableCellCentered()}
                  body={ocorrencia => (
                    <CustomCheckbox disabled checked={ocorrencia.devolucao_fisica} />
                  )}
                />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered()}
                  body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.actived} />}
                />
              </DataTable>
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
      <ModalOcorrencia
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

export default connect()(withRouter(OcorrenciaEmpresa))
